/** Route name -> i18n locale key for geoFaq/seo */
export const ROUTE_LOCALE_KEY = {
  home2: 'mainContent',
  directorsOfficers: 'directorsOfficers',
  mergersAcquisitions: 'mergersAcquisitions',
  propertyCasualty: 'propertyCasualty',
  cyberSecurity: 'cyberSecurity',
  employeeBenefits: 'employeeBenefits',
  globalClients: 'globalClients',
  privateEquity: 'privateEquity',
  foodBeverage: 'foodBeverage',
  manufacturingTechnology: 'manufacturingTechnology',
  sportsEntertainmentEvents: 'sportsEntertainmentEvents',
  automotiveInfrastructure: 'automotiveInfrastructure',
  realEstateConstructions: 'realEstateConstructions',
  lifeScience: 'lifeScience',
  financialInstitutions: 'financialInstitutions',
  energyPower: 'energyPower',
  AboutUs: 'aboutUs',
  companyFacts: 'companyFacts',
  news: 'newsPage',
  Individuals: 'individuals',
  personal: 'personal',
  highEnd: 'highEnd',
  children: 'children',
  elderly: 'elderly',
  life: 'life',
  travel: 'travel',
  student: 'student',
  business: 'business',
  residence: 'residence',
  seeall: 'seeall'
}

export const PUBLIC_ROUTES = [
  '/',
  '/directorsOfficers',
  '/mergersAcquisitions',
  '/propertyCasualty',
  '/cyberSecurity',
  '/employeeBenefits',
  '/globalClients',
  '/privateEquity',
  '/foodBeverage',
  '/manufacturingTechnology',
  '/sportsEntertainmentEvents',
  '/automotiveInfrastructure',
  '/realEstateConstructions',
  '/lifeScience',
  '/financialInstitutions',
  '/energyPower',
  '/AboutUs',
  '/companyFacts',
  '/news',
  '/Individuals',
  '/personal',
  '/highEnd',
  '/children',
  '/elderly',
  '/life',
  '/travel',
  '/student',
  '/business',
  '/residence',
  '/seeall'
]

export const PRERENDER_ROUTES = [
  '/',
  '/directorsOfficers',
  '/mergersAcquisitions',
  '/cyberSecurity',
  '/propertyCasualty',
  '/employeeBenefits',
  '/globalClients',
  '/privateEquity',
  '/lifeScience',
  '/financialInstitutions',
  '/realEstateConstructions',
  '/automotiveInfrastructure',
  '/manufacturingTechnology',
  '/foodBeverage',
  '/energyPower',
  '/sportsEntertainmentEvents',
  '/AboutUs',
  '/companyFacts',
  '/news',
  '/Individuals',
  '/personal',
  '/highEnd',
  '/children',
  '/elderly',
  '/life',
  '/travel',
  '/student',
  '/business',
  '/residence',
  '/seeall'
]
